import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';
import { sessionService } from '../../services/SessionService';

interface NewAntennaProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class NewAntenna extends React.Component<NewAntennaProps> {

    @observable private antenna: any = {
        antenna_name: "",
        name: "",
        phone: "",
        address_street: "",
        address_colonia : "",
        amount: ""
    };
    @observable private redirect = false;
    @observable private validationErrors:string[] = [
        "antenna_name",
        "name",
        "phone",
        "address_street",
        "address_colonia",
        "amount"
    ];

    componentDidMount() {
        this.props.changeToggle(true);
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.antenna[name] = value;
    }

    private setValidation = (value:boolean, name:string):void =>{
        const error = this.validationErrors.indexOf(name);
        if(value && error === -1) {
            this.validationErrors.push(name);
        } else if(!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {
        this.antenna.created_by = sessionService.getUserInfo().id;
        this.antenna.amount = this.antenna.amount.replace("$",'').replace(/,/g, '');
        this.antenna.phone = this.antenna.phone.replace(/-/g, '');

        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }
        
        http.post(`/api/antenna/create`, JSON.stringify(this.antenna))
            .then(() => {
                toast.success(`Antena agregada`);
                this.redirect = true;
            }).catch((error)=>{
                if(Array.isArray(error)) {
                    error.forEach((val) =>{
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }

    render() {
        if (this.redirect) {
            return <Redirect to="/antenas" />
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Antena: {this.antenna.antenna_name}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`../antenas`}>
                                            <button className="btn btn-danger btn-sm  pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <InputForm
                                    name="antenna_name"
                                    label="Nombre de la Antena"
                                    value={this.antenna.antenna_name}
                                    required={true}
                                    setValidation={this.setValidation}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="name"
                                    label="Nombre"
                                    value={this.antenna.name}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="address_street"
                                    label="Calle"
                                    value={this.antenna.address_street}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="address_colonia"
                                    label="Colonia"
                                    value={this.antenna.address_colonia}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="phone"
                                    label="Teléfono"
                                    value={this.antenna.phone}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="number"
                                    format={"###-###-####"}
                                />
                                <InputForm
                                    name="amount"
                                    label="Cantidad"
                                    value={this.antenna.amount}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="number"
                                    prefix="$"
                                    decimal={2}
                                    thousandSeparator={true}
                                />
                                <button onClick={this.onSubmit} type="submit" className="btn btn-primary pull-right">Crear Antena</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}